































































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IOffice } from '@/entities/offices/office.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import profileApi from '@/api/profile.api';

const passwordDefaultValidator = 'confirmed:passwordConfirm';

@Component({})
export default class ProfileOffice extends EditPage {
    public parentPath: string = '/app/home';

    public formState: IDictionary<IFormControl> = {
        officeName: {
            key: 'officeName',
            label: 'Office Name',
            value: '',
            validators: 'required'
        },
        manFirstName: {
            key: 'manFirstName',
            label: `Manager's First Name`,
            value: '',
            validators: 'required'
        },
        manLastName: {
            key: 'manLastName',
            label: `Manager's Last Name`,
            value: '',
            validators: 'required'
        },
        manEmail: {
            key: 'manEmail',
            label: 'Email',
            value: '',
            validators: 'required|email'
        },
        password: {
            key: 'password',
            label: 'Password',
            value: '',
            validators: passwordDefaultValidator
        },
        passwordConfirm: {
            key: 'passwordConfirm',
            label: 'Confirm Password',
            value: '',
            validators: ''
        },
        agentNotes: {
            key: 'agentNotes',
            label: 'Must Read (optional)',
            value: ''
        },
        activated: {
            key: 'activated',
            label: 'Activated',
            value: true
        }
    };

    public async created() {
        super.created();
        this.isNew = false;
        this.loading = true;
        try {
            const details = await profileApi.companyDetails();
            this.setValues(details);
        } finally {
            this.loading = false;
        }
    }

    protected create(id: number): Promise<any> {
        throw new Error('not supported');
    }

    protected detail(body: any): Promise<any> {
        throw new Error('not supported');
    }

    protected update(body: any): Promise<number> {
        return profileApi.updateCompany(body);
    }
}
